import classNames from 'classnames';

interface TestCountWarpperPros {
  title: string;
  count: number;
  totalCount: number;
  countColor?: string;
}

export const TestCountWarpper: React.FC<TestCountWarpperPros> = ({
  title,
  count,
  totalCount,
  countColor,
}) => (
  <div className='flex'>
    <div className='bg-secondary-50 p-2 rounded-lg'>
      <div
        className='bg-white flex items-center px-3 py-2.5 rounded-lg font-medium'
        style={{
          boxShadow:
            '0px 0.3px 0.9px rgba(0, 0, 0, 0.07), 0px 1.6px 3.6px rgba(0, 0, 0, 0.11)',
        }}>
        <div className='text-secondary-600 text-small leading-5'>{title}</div>
        <div className='pl-4 text-lg'>
          <span
            className={classNames(
              countColor ? countColor : 'text-primary-500',
            )}>
            {count}
          </span>
          <span className='inline-flex pl-0.5 text-unique-800'>
            / {totalCount}
          </span>
        </div>
      </div>
    </div>
  </div>
);
